import React, { useState } from "react";
import { BRAND, I18N } from "../../mock";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../components/ui/select";
import { Button } from "../../components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "../../components/ui/sheet";
import { Menu } from "lucide-react";

export const Header = ({ lang, setLang }) => {
  const t = I18N[lang];
  const [open, setOpen] = useState(false);

  const NavLinks = ({ onClick }) => (
    <nav className="flex flex-col md:flex-row md:items-center gap-6 text-white/90">
      <a onClick={onClick} className="hover:text-white transition-colors" href="#about">{t.nav.about}</a>
      <a onClick={onClick} className="hover:text-white transition-colors" href="#services">{t.nav.services}</a>
      <a onClick={onClick} className="hover:text-white transition-colors" href="#why">{t.nav.why}</a>
      <a onClick={onClick} className="hover:text-white transition-colors" href="#videos">{t.nav.videos}</a>
      <a onClick={onClick} className="hover:text-white transition-colors" href="#lead">{t.nav.contact}</a>
    </nav>
  );

  return (
    <header className="sticky top-0 z-50 bg-black/80 backdrop-blur-md border-b border-[#2a2a2a]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-5 py-3 md:py-6 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 min-w-0">
          <img src={BRAND.logoUrl} alt="MICE Travel" className="h-[120px] w-auto" />
        </a>

        {/* Desktop nav */}
        <div className="hidden md:flex items-center gap-8 md:ml-[1cm] md:pr-[1cm]">
          <NavLinks />
        </div>

        {/* Right actions */}
        <div className="hidden md:flex items-center gap-3">
          <Select value={lang} onValueChange={setLang}>
            <SelectTrigger className="w-[130px] bg-transparent text-white border-[#444]">
              <SelectValue placeholder="Idioma" />
            </SelectTrigger>
            <SelectContent className="bg-black text-white border-[#333]">
              <SelectItem value="pt">🇧🇷 {I18N.pt.langLabel}</SelectItem>
              <SelectItem value="en">🇺🇸 {I18N.en.langLabel}</SelectItem>
            </SelectContent>
          </Select>
          <Button asChild className="rounded-none border border-[#D4AF37] text-[#D4AF37] bg-transparent hover:bg-[#D4AF37] hover:text-black">
            <a href="#lead">{t.hero.cta}</a>
          </Button>
        </div>

        {/* Mobile menu */}
        <div className="md:hidden flex items-center gap-2">
          <Button asChild size="sm" className="rounded-none border border-[#D4AF37] text-[#D4AF37] bg-transparent hover:bg-[#D4AF37] hover:text-black">
            <a href="#lead">{t.hero.cta}</a>
          </Button>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="outline" size="icon" className="border-white/20 bg-white/5 text-white">
                <Menu size={18} />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-black text-white border-white/10 w-[320px]">
              <div className="mt-10 flex flex-col gap-6">
                <Select value={lang} onValueChange={(v) => { setLang(v); setOpen(false); }}>
                  <SelectTrigger className="bg-transparent text-white border-[#444]">
                    <SelectValue placeholder="Idioma" />
                  </SelectTrigger>
                  <SelectContent className="bg-black text-white border-[#333]">
                    <SelectItem value="pt">🇧🇷 {I18N.pt.langLabel}</SelectItem>
                    <SelectItem value="en">🇺🇸 {I18N.en.langLabel}</SelectItem>
                  </SelectContent>
                </Select>
                <NavLinks onClick={() => setOpen(false)} />
                <div className="pt-2">
                  <Button asChild className="w-full rounded-none bg-[#D4AF37] text-black hover:bg-[#c19a2f]">
                    <a href={BRAND.whatsapp} target="_blank" rel="noreferrer">WhatsApp</a>
                  </Button>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};
